import moment from "moment";

export const toPositiveNum = num => {
    return (typeof num !== 'number' || isNaN(num)) ? 0 : Math.abs(num);
}

export const isCurrencyField = (key, value) => {
    const keyLcase = key.toLowerCase();
    return parseInt(value) && (keyLcase.includes('dollar') || keyLcase.includes('value'))
}

export const checkAndFormatDate = (value) => {
    if (
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value) ||
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value)
    ) {
        return moment(value).format("YYYY-MM-DD HH:mm:ss")
    }
    return value ?? "";
}

export const getMaxValueLength = (arr) => {
    let keyLength = 0;
    arr.forEach(k => {
        keyLength =  Math.max(k.length, keyLength);
    })
    return keyLength;
}